"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Describes the markup on Labor products for the solutions defined in this object.
 * The amount corresponds to the amount of the product on a quote, and the markup
 * of that amount is the markup on the labor product.
 * The markup should be linearly interpolated between the amounts if the amount of the
 * quote does not exactly match one of the amounts in the array.
 */
const tieredPrices = {
    wallInsulation: [
        // Note: 2024-09-09: Halved all markups for an experiment to sell quotes closer to market prices
        // Should be reverted after two weeks: 2024-09-23
        { amount: 1, markup: 0.5 * 2.5 },
        { amount: 10, markup: 0.5 * 2.5 },
        { amount: 20, markup: 0.5 * 2 },
        { amount: 30, markup: 0.5 * 2 },
        { amount: 40, markup: 0.5 * 1.5 },
        { amount: 50, markup: 0.5 * 1.25 },
        { amount: 60, markup: 0.5 * 1 },
        { amount: 70, markup: 0.5 * 0.8 },
        { amount: 80, markup: 0.5 * 0.7 },
        { amount: 160, markup: 0.5 * 0.3 },
    ],
    floorInsulation: [
        { amount: 1, markup: 0.5 * 2.5 },
        { amount: 10, markup: 0.5 * 2.5 },
        { amount: 20, markup: 0.5 * 2.25 },
        { amount: 30, markup: 0.5 * 2 },
        { amount: 40, markup: 0.5 * 0.7 },
        { amount: 50, markup: 0.5 * 0.7 },
        { amount: 60, markup: 0.5 * 0.65 },
        { amount: 70, markup: 0.5 * 0.65 },
        { amount: 80, markup: 0.5 * 0.6 },
        { amount: 90, markup: 0.5 * 0.6 },
        { amount: 150, markup: 0.5 * 0.3 },
    ],
    crawlspaceInsulation: [
        { amount: 1, markup: 0.5 * 2.5 },
        { amount: 10, markup: 0.5 * 2.5 },
        { amount: 20, markup: 0.5 * 2.25 },
        { amount: 30, markup: 0.5 * 2 },
        { amount: 40, markup: 0.5 * 0.7 },
        { amount: 50, markup: 0.5 * 0.7 },
        { amount: 60, markup: 0.5 * 0.65 },
        { amount: 70, markup: 0.5 * 0.65 },
        { amount: 80, markup: 0.5 * 0.6 },
        { amount: 90, markup: 0.5 * 0.6 },
        { amount: 150, markup: 0.5 * 0.3 },
    ],
    innerRoofInsulation: [
        { amount: 1, markup: 0.5 * 2.5 },
        { amount: 10, markup: 0.5 * 2.5 },
        { amount: 20, markup: 0.5 * 2.25 },
        { amount: 30, markup: 0.5 * 2 },
        { amount: 40, markup: 0.5 * 0.7 },
        { amount: 50, markup: 0.5 * 0.7 },
        { amount: 60, markup: 0.5 * 0.65 },
        { amount: 70, markup: 0.5 * 0.65 },
        { amount: 80, markup: 0.5 * 0.6 },
        { amount: 90, markup: 0.5 * 0.6 },
        { amount: 150, markup: 0.5 * 0.3 },
    ],
    atticFloorInsulation: [
        { amount: 1, markup: 0.5 * 2.5 },
        { amount: 10, markup: 0.5 * 2.5 },
        { amount: 20, markup: 0.5 * 2.25 },
        { amount: 30, markup: 0.5 * 2 },
        { amount: 40, markup: 0.5 * 0.7 },
        { amount: 50, markup: 0.5 * 0.7 },
        { amount: 60, markup: 0.5 * 0.65 },
        { amount: 70, markup: 0.5 * 0.65 },
        { amount: 80, markup: 0.5 * 0.6 },
        { amount: 90, markup: 0.5 * 0.6 },
        { amount: 150, markup: 0.5 * 0.3 },
    ],
};
exports.default = tieredPrices;
